import {management} from '../../../../index'

import {FarmsDapRepository} from '../../../infra/knex/repositories/farmsDapRepository'
import {CheckIfExistsFarmDapUseCase} from './checkIfExistsFarmDap'


export const checkIfFarmDapExists=new CheckIfExistsFarmDapUseCase(new FarmsDapRepository(management))
